{
  "fr": {
    "baseChip": {
      "states": {
        "included": "inclus",
        "excluded": "exclu"
      }
    }
  }
}
